import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { IAirdropTaskRender } from "./task-renderer.types";
import { QuestTaskButton } from "../quest-task-button";
import { cn } from "@/lib/utils";

export const TwitterUsernameRenderer = ({
  task,
  campaign,
  completeTaskMutation,
}: IAirdropTaskRender) => {
  const [copied, setCopied] = useState(false);
  const swapperVibes = "🟣🟢";

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(swapperVibes);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <div className="flex flex-col gap-6">
      <div className="relative bg-white border-2 border-swapper-primary/20 rounded-2xl p-6 shadow-lg">
        <p className="text-sm text-swapper-secondary mb-4 leading-relaxed">
          To complete this task, add the Swapper Vibes 🟣🟢 to your X name.
        </p>
        <div className="flex items-center gap-3">
          <div className="relative flex items-center justify-center bg-swapper-primary/10 px-6 py-3 rounded-xl border-2 border-swapper-primary/20">
            <span className="text-2xl font-bold">🟣🟢</span>
          </div>
          <Button
            variant={copied ? "secondary" : "primary"}
            size="sm"
            onClick={handleCopy}
            className="whitespace-nowrap"
          >
            {copied ? (
              <>
                <Check className="w-4 h-4 mr-2" />
                Copied!
              </>
            ) : (
              <>
                <Copy className="w-4 h-4 mr-2" />
                Copy Symbols
              </>
            )}
          </Button>
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <h4 className="font-bold text-swapper-secondary">
          How to update your name:
        </h4>
        <ol className="list-decimal list-inside space-y-2 text-sm text-swapper-secondary/70 leading-relaxed">
          <li>Click the "Copy Symbols" button above</li>
          <li>Go to your X profile settings</li>
          <li>Click "Edit profile"</li>
          <li>Add 🟣🟢 to your name field</li>
          <li>Save your changes</li>
          <li>Come back here and click "Verify & Claim"</li>
        </ol>
      </div>

      <QuestTaskButton
        buttonText="Verify & Claim"
        taskMutation={completeTaskMutation}
        task={task}
        onClick={() => {
          completeTaskMutation.mutateAsync({
            taskGuid: task.taskGuid,
            taskName: task.taskName,
            campaignId: campaign.id,
            extraArguments: task.extraArguments,
            groupId: campaign.campaignGroup,
          });
        }}
      />
    </div>
  );
};
